<header id="ebo-top-header" [ngClass]="{'blurred': drawer.opened}">
  <div class="logo-va">
    <a [routerLink]="[hasEnvironmentPermission ? '/test/dashboard/view' : '/prod/dashboard/view']">
      <img alt="EBO" class="topbar-logo" [src]="(logoSrc$ | async)" />
    </a>

    <ng-container *appHasPermission="'select-agent.view'">
      <ebo-dropdown
        *ngIf="((botOptions$ | async)?.length > 0 && hideVASelector == false) && (isBotCreated$ | async)"
        [title]="'Virtual Agent'"
        [options]="botOptions$ | async"
        [value]="selectedBotId$ | async"
        (selectionChange)="setBot($event)"
        [placeholder]="'Select a Virtual Agent'"
      >
      </ebo-dropdown>
    </ng-container>

    <ng-container *ngIf="hasEnvironmentPermission; else noPermission">
      <div *ngIf="(isBotCreated$ | async)" class="environments">
        <mat-button-toggle-group
          #group="matButtonToggleGroup"
          (change)="setEnvironment(group.value)"
          [value]="(environment$ | async)"
          class="toggle-buttons"
        >
          <mat-button-toggle id="env-production" value="Prod">
            <ng-container *ngIf="tablet; else iconProd">
              <span>Production</span>
            </ng-container>
            <ng-template #iconProd>
              <span class="icon">
                <mat-icon aria-hidden="true" svgIcon="env_production"></mat-icon>
              </span>
            </ng-template>
          </mat-button-toggle>
          <mat-button-toggle id="env-test" value="Test">
            <ng-container *ngIf="tablet; else iconTest">
              <span>Test</span>
            </ng-container>
            <ng-template #iconTest>
              <span class="icon">
                <mat-icon aria-hidden="true" svgIcon="env_test"></mat-icon>
              </span>
            </ng-template>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </ng-container>

    <ng-template #noPermission>
      <div *ngIf="(isBotCreated$ | async)" class="environments">
        <mat-button-toggle-group #group="matButtonToggleGroup" class="toggle-buttons" value="Prod">
          <mat-button-toggle value="Prod">
            <span>Production</span>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </ng-template>
  </div>
  <div class="ebo-icons">
    <div class="network">
      <ng-container *ngIf="!hubStatus && (isBotCreated$ | async); else noConnection">
        <button class="w-rounded" mat-icon-button>
          <mat-icon aria-hidden="false" aria-label="Network On" svgIcon="network_on"></mat-icon>
        </button>
      </ng-container>
      <ng-template #noConnection>
        <button class="w-rounded" mat-icon-button>
          <mat-icon
            aria-hidden="false"
            aria-label="Network Off"
            svgIcon="network_off"
            color="warn"
            matTooltip="Network connection lost. Some features may not work properly."
            matTooltipPosition="below"
          ></mat-icon>
        </button>
      </ng-template>
    </div>

    <div class="notifications">
      <ebo-notifications></ebo-notifications>
    </div>

    <ng-container *appHasPermission="'settings.view'">
      <button (click)="settings()" *ngIf="(isBotCreated$ | async)" class="settings w-rounded" mat-icon-button>
        <mat-icon aria-hidden="false" aria-label="Settings" svgIcon="settings"></mat-icon>
      </button>
    </ng-container>

    <ng-container *ngIf="!tablet; else desktopMenu">
      <button mat-icon-button (click)="drawer.toggle()" aria-label="Side menu" class="mobile-menu drawer-toggle-btn">
        <mat-icon aria-hidden="false" aria-label="Menu" svgIcon="dots"></mat-icon>
      </button>
    </ng-container>

    <ng-template #desktopMenu>
      <ng-container>
        <button mat-icon-button [matMenuTriggerFor]="accountMenu" class="account">
          <ngx-avatars size="40" [src]="(picture$ | async)" [name]="(fullName$ | async)"></ngx-avatars>
        </button>
        <mat-menu #accountMenu="matMenu">
          <ng-container *ngIf="!(isAzure$ | async)">
            <button id="reset-password" mat-menu-item (click)="resetOurPassword()">
              <!-- TODO: Replace Icon with SVG from Figma  -->
              <mat-icon>lock</mat-icon>
              <span>Reset password</span>
            </button>
          </ng-container>
          <button id="signout" mat-menu-item (click)="signOut()">
            <mat-icon>exit_to_app</mat-icon>
            <span>Sign out</span>
          </button>
        </mat-menu>
      </ng-container>
    </ng-template>
  </div>
</header>
